import { Height } from "@mui/icons-material";
import color from "../../../../../constants/color";

const style = {
  heading: {
    fontSize: "20px",
    fontWeight: "600",
    pl: 2,
  },

  card: {
    backgroundColor: "#fff",
    margin: 2,
    px: "20px",
    py: "20px",
    borderRadius: "20px",
    paddingBottom: "25px",
    "& .css-a5rdam-MuiGrid-root": {
      marginTop: "11px",
    },
  },

  inputSection: {
    display: { sx: "block", md: "flex" },
    justifyContent: "start",
    gap: "20px",
    alignItems: "start",
    px: 2,
  },

  inputBox: {
    width: { xs: "100%", md: "49%", lg: "31%" },
  },

  inputText: {
    fontSize: "12px",
    fontWeight: "500",
    color: color.text,
    mt: 1,
  },

  uploadSection: {
    px: 2,
    width: { xs: "100%", md: "55%" },

    "& .css-2y07vr": {
      py: "7px"

    }
  },

  uploadText: {
    fontSize: "14px",
    fontWeight: "400",
    color: color.lightText,
    mt: 2,
    mb: 1,
  },

  chooseIconSection: {
    backgroundColor: color.primary,
    display: "flex",
    p :1,
    mx:1,
    borderRadius: "9px", 
    width: "fit-content",
  },

  choose: {
    fontSize: "14px",
    color: color.card,
  },

  dragAndDrop: {
    border: "2px dashed #D9D9D9",
    borderRadius: "8px",
    p: 3,
    width: "782px",
    textAlign: "center",
    cursor: "pointer",
    bgcolor: "#fff",
  },

  saveBtn: {
    width: "95px",
    Height: "37px",
    borderRadius: 50, 
    textTransform: "none" , 
    backgroundColor: "#28AA4A",
    fontSize: "14px",
  },

  encodingInput: {
    width: "100%",
    borderRadius: "8px",
    height: "2.5em",
    mt: 1,

    "& .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": {
      padding: "8.5px 14px",
      borderRadius: "8px",
    },
    "& .css-156w56f-MuiInputBase-root-MuiOutlinedInput-root": {
      borderRadius: "8px",
    },
    ".css-3dzjca-MuiPaper-root-MuiPopover-paper-MuiMenu-paper": {
      maxWidth: "25%",
    },
  },
}

export default style;